import script from "./TournamentEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentEdit.vue?vue&type=script&setup=true&lang=js"

import "./TournamentEdit.vue?vue&type=style&index=0&id=5be5cae7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5be5cae7"]])

export default __exports__